module.exports = __webpack_public_path__ + "static/img/help8.88709ad3.png";